'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails from "./app.data.-Payment-Details.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$UnitedKingdom(accountNumber, sortCode) {
  this.LQ = null;
  this.LR = null;
  this.LQ = accountNumber;
  this.LR = sortCode;
}
export { $c_Lapp_data_PaymentDetails$UnitedKingdom as $c_Lapp_data_PaymentDetails$UnitedKingdom };
$p = $c_Lapp_data_PaymentDetails$UnitedKingdom.prototype = new $j_app$002edata$002e$002dPayment$002dDetails.$h_Lapp_data_PaymentDetails();
$p.constructor = $c_Lapp_data_PaymentDetails$UnitedKingdom;
/** @constructor */
function $h_Lapp_data_PaymentDetails$UnitedKingdom() {
}
export { $h_Lapp_data_PaymentDetails$UnitedKingdom as $h_Lapp_data_PaymentDetails$UnitedKingdom };
$h_Lapp_data_PaymentDetails$UnitedKingdom.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_PaymentDetails$UnitedKingdom) && ((this.LQ === x$0.LQ) && (this.LR === x$0.LR))));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "UnitedKingdom";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.LQ;
  }
  if ((n === 1)) {
    return this.LR;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "accountNumber";
  }
  if ((n === 1)) {
    return "sortCode";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_PaymentDetails$UnitedKingdom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jM)));
}
export { $isArrayOf_Lapp_data_PaymentDetails$UnitedKingdom as $isArrayOf_Lapp_data_PaymentDetails$UnitedKingdom };
var $d_Lapp_data_PaymentDetails$UnitedKingdom = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$UnitedKingdom, "app.data.PaymentDetails$UnitedKingdom", ({
  jM: 1,
  jK: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_PaymentDetails$UnitedKingdom as $d_Lapp_data_PaymentDetails$UnitedKingdom };
//# sourceMappingURL=app.data.-Payment-Details$-United-Kingdom.js.map
